import { useEffect } from 'react';
import {useDispatch, useSelector} from "react-redux";
import {askPin, setLastSeen} from "../redux/pin/pinSlice";
import moment from "moment";
const useUserActivity = ()=> {

    // var lastSeen = moment(useSelector((state) => state.pin.lastSeen));
    var lastSeen = null;
    const dispatch = useDispatch();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {

        function checkLastSeen(event){
            // if(moment().diff(lastSeen,'minute')>15){
            if(false){
                dispatch(askPin({value : true }));
                dispatch(setLastSeen());
                lastSeen  = moment();
            }else {
                dispatch(setLastSeen());
                lastSeen  = moment();
            }
        }

        const events = ['focus', 'mousemove', 'keypress'];

        events.forEach((e) => window.addEventListener(e, checkLastSeen))

        return () => {
            events.forEach((e) => window.removeEventListener(e, checkLastSeen))
        }
    }, []);
};
export default useUserActivity;
